import styled from 'styled-components';
import { getPaymentStatusColor } from '../../../../Utils/paymentStatus';

export const Label = styled.span`
  color: #737273;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
`;

export const Value = styled.span`
  margin-left: 10px;
  font-size: 12px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  color: ${(props) => {
    if (props.$status) {
      if (props.children) {
        return getPaymentStatusColor(props.children);
      }
    } else {
      return '#000';
    }
  }};
`;
